import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useViewer from '@hooks/useViewer';
import { getLoginPath } from '../../../../helpers/url.helpers';

const CartPaymentPageOuter = ({ children }) => {
    const history = useHistory();
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });

    if (viewer === null) {
        // eslint-disable-next-line no-undef
        window.location.href = getLoginPath();
    }

    if (cart && cart.items.length === 0) {
        history.push('/cart/view');
    }

    return children;
};

CartPaymentPageOuter.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CartPaymentPageOuter;
